module.exports = __webpack_public_path__ + "img/section1.d98ba556.png";